import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ToastContainer, toast, cssTransition } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

export default class Toast extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };

    this.activate = this.activate.bind(this);
  }

  componentDidMount() {
    this.activate();
  }

  componentDidUpdate() {
    this.activate();
  }

  activate() {
    const {
      trigger, content, type, delay, incrementAutoClose, autoClose,
    } = this.props;

    if (trigger) {
      const triggerToast = type !== null ? toast[type] : toast;
      toast.dismiss();

      setTimeout(() => {
        if (typeof content === 'object') {
          Object.values(content).forEach((c, i) => {
            const closeDelay = incrementAutoClose ? ((((Object.values(content).length + 1) - (i + 1)) * autoClose)) : autoClose;
            triggerToast(c, {
              ...this.props,
              autoClose: closeDelay,
              limit: 1
            });
          });
        } else {
          triggerToast(content, {
            ...this.props,
            limit: 1
          });
        }
      }, delay);
    }
  }

  render() {
    const { transition } = this.props;

    return (
      <ToastContainer
        transition={
          typeof transition === 'object'
            ? cssTransition(transition)
            : transition
        }
        limit={1}
        {...this.props}
      />
    );
  }
}

Toast.propTypes = {
  autoClose: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  closeButton: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
  closeOnClick: PropTypes.bool,
  content: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.arrayOf([
      PropTypes.element,
      PropTypes.string,
    ]),
  ]),
  delay: PropTypes.number,
  draggable: PropTypes.bool,
  hideProgressBar: PropTypes.bool,
  incrementAutoClose: PropTypes.bool,
  newestOnTop: PropTypes.bool,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  pauseOnHover: PropTypes.bool,
  position: PropTypes.string,
  transition: PropTypes.oneOfType([PropTypes.func, PropTypes.shape()]),
  trigger: PropTypes.bool,
  type: PropTypes.string,
};

Toast.defaultProps = {
  autoClose: 20000,
  closeButton: false,
  closeOnClick: true,
  content: 'DEFAULT TOAST CONTENT',
  delay: 0,
  draggable: true,
  hideProgressBar: false,
  incrementAutoClose: true,
  limit: 1,
  newestOnTop: true,
  onClose: () => { },
  onOpen: () => { },
  pauseOnHover: true,
  position: 'top-center',
  transition: cssTransition({
    enter: 'zoomIn',
    exit: 'zoomOut',
    duration: [500, 800],
  }),
  trigger: false,
  type: 'success',
};

